import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  useTheme,
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useTranslation } from 'react-i18next';
import { serviceDefinitions } from './serviceDefinitions';

const sectionKeys = ['kitchen', 'bathroom', 'rooms'] as const;

export default function OfficeServiceDialogContent() {
  const { t } = useTranslation();
  const theme = useTheme();
  const service = serviceDefinitions.office_clean;

  const renderCompactList = (items: string[]) => (
    <List disablePadding>
      {items.map((item) => (
        <ListItem key={item} disableGutters sx={{ py: 0.25 }}>
          <ListItemIcon sx={{ minWidth: 30 }}>
            <CheckCircleOutlineIcon
              fontSize='small'
              sx={{ color: theme.palette.secondary.main }}
            />
          </ListItemIcon>
          <ListItemText
            primary={item}
            primaryTypographyProps={{
              variant: 'body2',
              sx: { color: '#333', fontWeight: 500 },
            }}
          />
        </ListItem>
      ))}
    </List>
  );

  const sectionCardSx = {
    p: 2,
    borderRadius: 2,
    border: '1px solid rgba(45, 0, 84, 0.12)',
    backgroundColor: '#fff',
  };

  return (
    <>
      <Typography
        variant='subtitle2'
        sx={{ color: '#555', lineHeight: 1.75, mb: 2.5 }}
      >
        {t(service.detailKey)}
      </Typography>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
          gap: 1.5,
        }}
      >
        <Box
          sx={{
            ...sectionCardSx,
            gridColumn: { xs: '1', md: '1 / -1' },
            backgroundColor: 'rgba(45, 0, 84, 0.03)',
          }}
        >
          <Typography variant='body2' sx={{ color: '#444', lineHeight: 1.7 }}>
            {t('services.office_clean_price_note')}
          </Typography>
        </Box>

        {sectionKeys.map((sectionKey) => {
          const items = t(`services.office_clean_sections.${sectionKey}.items`, {
            returnObjects: true,
          });
          const itemList = Array.isArray(items) ? items : [];

          return (
            <Box
              key={sectionKey}
              sx={{
                ...sectionCardSx,
                gridColumn:
                  sectionKey === 'rooms'
                    ? { xs: '1', md: '1 / -1' }
                    : undefined,
              }}
            >
              <Typography
                variant='subtitle1'
                sx={{ fontWeight: 700, mb: 0.75 }}
              >
                {t(`services.office_clean_sections.${sectionKey}.title`)}
              </Typography>
              {renderCompactList(itemList)}
            </Box>
          );
        })}
      </Box>
    </>
  );
}
